import React from 'react';
import { Box, CssBaseline, ThemeProvider, Typography } from '@mui/material';
import ConstructionPriceEstimator from '../stages/ConstructionPriceEstimator';
import { FlowContext } from '../components/StageWrapper';
import { createAppTheme } from '../theme';

/**
 * Opt-in browser harness for a real local API and a disposable copied flow.
 *
 * It intentionally provides neither a fetch shim nor sample estimate data.
 * The caller must point REACT_APP_API_URL at a loopback API whose storage is a
 * disposable copy of the named SOW and whose DATA_DIR contains reviewed local
 * snapshot evidence. This keeps an end-to-end check from reading a developer's
 * normal flows or a deployed environment.
 */
export default function ActualComponentQueueFixture() {
  const flowId = process.env.REACT_APP_E2E_COMPONENT_QUEUE_FLOW_ID?.trim();
  if (!flowId) {
    return <Typography role="alert">An explicit disposable flow ID is required for this browser check.</Typography>;
  }

  return (
    <ThemeProvider theme={createAppTheme()}>
      <CssBaseline />
      <FlowContext.Provider value={{
        flowName: 'LOCAL ONLY — Base Camp component-queue browser check',
        canGoBack: false,
        standaloneMode: false,
        isViewOnly: false,
      }}>
        <Box component="main" data-testid="actual-component-queue-e2e-shell" sx={{ maxWidth: 1200, mx: 'auto', px: 3, py: 3 }}>
          <Typography variant="overline" color="primary">Local browser test</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            This page uses the live loopback API and its isolated Base Camp flow copy. It has no in-browser source or response fixture.
          </Typography>
          <ConstructionPriceEstimator flowId={flowId} pollIntervalMs={250} />
        </Box>
      </FlowContext.Provider>
    </ThemeProvider>
  );
}
